import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import TeacherDashboard from './pages/TeacherDashboard';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import StudentDetailsPage from './pages/StudentDetailsPage';
import TestTakingPage from './pages/TestTakingPage';
import TestCompletionPage from './pages/TestCompletionPage';
import AccountValidationPage from './pages/AccountValidationPage';
import AccountActivationPage from './pages/AccountActivationPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/teacher" element={<TeacherDashboard />} />
          <Route path="/student-details" element={<StudentDetailsPage />} />
          <Route path="/take-test" element={<TestTakingPage />} />
          <Route path="/completion" element={<TestCompletionPage />} />
          <Route path="/validate/:uuid" element={<AccountValidationPage />} />
          <Route path="/activate/:uuid" element={<AccountActivationPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
